import Slice from './Slice';

export default class FirstLevelSlice extends Slice {};